import { render, staticRenderFns } from "./DetailInsight.vue?vue&type=template&id=1da5dd82&scoped=true&"
import script from "./DetailInsight.vue?vue&type=script&lang=js&"
export * from "./DetailInsight.vue?vue&type=script&lang=js&"
import style0 from "./DetailInsight.vue?vue&type=style&index=0&id=1da5dd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5dd82",
  null
  
)

export default component.exports